import React, {useState, useEffect} from "react";
import Table2 from "../../../components/common/Table/Table2";
import SkeletonElement from "../../../components/Skeletons/SkeletonElement";
import Search from "../../../components/common/Search";
import Modal from "../../../components/common/Modal";
import {useNavigate, Link, useParams} from "react-router-dom";
import Lightbox from "react-image-lightbox";
import restService from "../../../services/restService";
import moment from "moment";
import {Empty} from "antd";
import AddWallet from "./AddWallet";

const defaultImg =
  "https://www.kindpng.com/picc/m/252-2524695_dummy-profile-image-jpg-hd-png-download.png";
const ReceiverProfile = () => {
  const {id} = useParams();

  const [loading, setLoading] = useState(false);

  const [suspendReceiver, setSuspendReceiver] = useState(undefined);
  const [user, setUser] = useState({});
  const [images, setImages] = useState([]);
  const [senders, setSenders] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [callback, setCallback] = useState(() => {});
  const [searchQuery, setSearchQuery] = useState("");

  const [lightBox, setLightBox] = useState({
    photoIndex: 0,
    isOpen: false,
  });

  const viewImage = (imagePath) => {
    setLightBox({...lightBox, isOpen: true});
    setImages([imagePath]);
  };

  const handleSuspend = () => {
    //API CALL to suspend or activate
    const status = user.status === "active" ? "suspended" : "active";
    restService.SendersApi.updateSender(id, {status}).then((response) => {
      setUser({...user, status});
    });
    setSuspendReceiver(undefined);
  };

  const fetchReceiverById = (id) => {
    restService.ReceiversApi.getReceiverById(id).then((response) => {
      if (response) {
        setUser(response.data.data);
      }
    });
  };

  const fetchTransactionsByReceiver = (id) => {
    restService.TransactionsApi.getTransactionsByReceiver(id).then(
      (response) => {
        if (response) {
          setTransactions(response.data.data.data);
        }
      }
    );
  };

  const fetchSendersByRecipient = (id) => {
    restService.SendersApi.getSendersByRecipient(id).then((response) => {
      if (response) {
        setSenders(response.data.data.data);
      }
    });
  };

  useEffect(() => {
    fetchReceiverById(id);
    fetchTransactionsByReceiver(id);
    fetchSendersByRecipient(id);
  }, [id]);

  // console.log(senders);

  const filteredSenders =
    searchQuery === ""
      ? senders
      : senders?.filter((item) =>
          (item?.firstname + item?.lastname)
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(searchQuery.toLowerCase().replace(/\s+/g, ""))
        );

  return (
    <>
      <div className="flex flex-col intro-y w-full gap-6 my-[5rem]">
        <div className="flex items-center gap-4">
          <Link to={`/`} className="cursor-pointer">
            <svg
              width="12"
              height="13"
              viewBox="0 0 12 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.77778 0L0 4.33333V13H3.61111V7.94444H7.94444V13H11.5556V4.33333L5.77778 0Z"
                fill="#495465"
              />
            </svg>
          </Link>

          <span>
            {" "}
            <svg
              width="9"
              height="11"
              viewBox="0 0 9 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.8846 4.58215L0.555664 0.397949V2.60847L6.55566 5.50978L0.555664 8.43084V10.6019L8.8846 6.43742V4.58215Z"
                fill="#D1D5DC"
              />
            </svg>
          </span>

          <Link className="cursor-pointer" to={"/receivers"}>
            All Receivers
          </Link>

          <span>
            {" "}
            <svg
              width="9"
              height="11"
              viewBox="0 0 9 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.8846 4.58215L0.555664 0.397949V2.60847L6.55566 5.50978L0.555664 8.43084V10.6019L8.8846 6.43742V4.58215Z"
                fill="#D1D5DC"
              />
            </svg>
          </span>

          <span className="px-4 py-2 rounded-xl bg-[#F7F8FD] border border-[#E3E8FF] ">
            {user?.firstname} {user?.lastname}
          </span>
        </div>

        <div className="md:grid w-full flex flex-col-reverse md:grid-cols-[75.5%,23%] gap-4">
          <div className="flex-[1.2] w-full px-8 border border-theme-31 rounded-md py-7 bg-white flex flex-col gap-4 ">
            <h2 className="text-base font-medium text-black">Transactions</h2>

            {!loading ? (
              <div className="flex w-full flex-col">
                <Table2
                  divide="no"
                  // headData={head}
                  tHead={
                    <>
                      <th className="">Sender</th>
                      <th className="">Amount Sent</th>
                      <th className="">Amount Received</th>
                      <th className="">Charge</th>
                      <th className="">Date</th>
                      <th className="text-center">Status</th>
                      <th className=""></th>
                    </>
                  }
                  // renderHead={(item, index) => renderHeadData(item, index)}
                >
                  {transactions.map((item, index) => (
                    <tr key={index} className="">
                      <td>
                        <div className="flex items-center gap-2">
                          <Link
                            to={`/sender/${item?.sender?.id}`}
                            className="text-black font-medium whitespace-nowrap "
                          >
                            {item?.sender?.firstname}
                            {item?.sender?.lastname}
                          </Link>
                        </div>
                      </td>
                      <td>
                        <p className="whitespace-nowrap ">
                          {item.source_currency} {item.send_amount}
                        </p>
                      </td>
                      <td>
                        <p className="whitespace-nowrap">
                          {" "}
                          {item.destination_currency} {item.receive_amount}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-black">
                          {" "}
                          {item.source_currency} {item.charge}
                        </p>
                      </td>
                      <td>
                        <p className="whitespace-nowrap">
                          {moment(new Date(item.created_at)).format(
                            "MMMM DD, YYYY"
                          )}
                        </p>
                      </td>
                      <td>
                        <p
                          className={`rounded-[100px] whitespace-nowrap status-${item?.transaction_status?.status?.toLowerCase()} text-center text-black px-4 py-1.5`}
                        >
                          {item?.transaction_status?.status}
                        </p>
                      </td>
                      <td>
                        <Link to={`/transaction/${item.id}`}>
                          <svg
                            className="cursor-pointer"
                            width="16"
                            height="10"
                            viewBox="0 0 16 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.8418 0C4.43271 0 1.52134 2.07333 0.341797 5C1.52134 7.92667 4.43271 10 7.8418 10C11.2509 10 14.1623 7.92667 15.3418 5C14.1623 2.07333 11.2509 0 7.8418 0ZM7.8418 8.33333C5.95998 8.33333 4.43271 6.84 4.43271 5C4.43271 3.16 5.95998 1.66667 7.8418 1.66667C9.72361 1.66667 11.2509 3.16 11.2509 5C11.2509 6.84 9.72361 8.33333 7.8418 8.33333ZM7.8418 3C6.70998 3 5.79634 3.89333 5.79634 5C5.79634 6.10667 6.70998 7 7.8418 7C8.97361 7 9.88725 6.10667 9.88725 5C9.88725 3.89333 8.97361 3 7.8418 3Z"
                              fill="#ACACAC"
                            />
                          </svg>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </Table2>

                {transactions.length < 1 && (
                  <div className="flex items-center justify-center h-[30vh]">
                    <Empty />
                  </div>
                )}
              </div>
            ) : (
              <div className="flex w-full flex-col">
                <Table2
                  // headData={head}
                  tHead={
                    <>
                      <th className="">Sender</th>
                      <th className="">Amount Sent</th>
                      <th className="">Amount Recieved</th>
                      <th className="">Charge</th>
                      <th className="">Date</th>
                      <th className="text-center">Status</th>
                      <th className=""></th>
                    </>
                  }
                  // renderHead={(item, index) => renderHeadData(item, index)}
                >
                  {Array(5)
                    .fill()
                    .map((item, index) => (
                      <tr key={index}>
                        {Array(7)
                          .fill()
                          .map((x, i) => (
                            <td key={i}>
                              <SkeletonElement type={"title"} />
                            </td>
                          ))}
                      </tr>
                    ))}
                </Table2>
              </div>
            )}
          </div>
          <div className="flex-[.8] w-full  flex flex-col gap-6 bg-white px-8 border border-theme-31 rounded-md py-7">
            <div className="flex flex-col gap-1">
              <span>
                <img
                  src={defaultImg}
                  alt=""
                  className="w-[30px] h-[30px] object-cover rounded-full"
                />
              </span>
              <p className="text-black text-base font-bold">
                {user.firstname} {user.lastname}
              </p>
              <p className="text-[#727681] text-xs">{user.email}</p>

              <div className="flex mt-2">
                {user.status === "active" ? (
                  <button
                    onClick={() => {
                      handleSuspend();
                    }}
                    className="rounded-md bg-[#EA3323] hover:bg-[#EA3323f1] transition py-2 px-4 text-white"
                  >
                    Suspend
                  </button>
                ) : (
                  <button
                    onClick={() => {
                      handleSuspend();
                    }}
                    className="rounded-md bg-[#006D49] hover:bg-[#006d49f1] transition py-2 px-4 text-white"
                  >
                    Activate
                  </button>
                )}
              </div>
            </div>

            <ul className="flex flex-col gap-2">
              <li className="flex items-center gap-2">
                <span>
                  <svg
                    width="31"
                    height="32"
                    viewBox="0 0 31 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      y="0.776367"
                      width="30"
                      height="30"
                      rx="3.5"
                      fill="#FBFBFB"
                      stroke="#DEDEDE"
                    />
                    <path
                      d="M19.4516 22.5705C18.8287 22.5705 17.9538 22.3452 16.6437 21.6133C15.0506 20.7199 13.8183 19.8951 12.2338 18.3147C10.7061 16.788 9.96267 15.7995 8.92218 13.9061C7.74671 11.7683 7.94709 10.6477 8.17108 10.1688C8.43782 9.59639 8.83156 9.25403 9.34048 8.91422C9.62954 8.72483 9.93544 8.56248 10.2543 8.42923C10.2862 8.41551 10.3159 8.40242 10.3424 8.39062C10.5003 8.31946 10.7396 8.21194 11.0427 8.3268C11.245 8.40274 11.4256 8.55813 11.7083 8.83732C12.2881 9.4091 13.0803 10.6825 13.3726 11.3079C13.5688 11.7294 13.6987 12.0076 13.699 12.3197C13.699 12.685 13.5152 12.9667 13.2922 13.2708C13.2504 13.3279 13.2089 13.3825 13.1687 13.4355C12.9259 13.7545 12.8726 13.8467 12.9077 14.0114C12.9789 14.3423 13.5095 15.3272 14.3815 16.1974C15.2535 17.0675 16.2101 17.5646 16.5423 17.6354C16.7139 17.6721 16.808 17.6166 17.1373 17.3652C17.1845 17.3291 17.233 17.2918 17.2838 17.2544C17.6239 17.0014 17.8926 16.8224 18.2493 16.8224H18.2512C18.5617 16.8224 18.8274 16.9571 19.2678 17.1791C19.8421 17.4689 21.1538 18.2509 21.7291 18.8313C22.0089 19.1134 22.1649 19.2933 22.2412 19.4953C22.3561 19.7994 22.2479 20.0377 22.1774 20.1972C22.1656 20.2237 22.1525 20.2528 22.1388 20.285C22.0045 20.6033 21.8412 20.9085 21.6509 21.1969C21.3117 21.7042 20.9681 22.097 20.3944 22.3641C20.0998 22.5034 19.7774 22.574 19.4516 22.5705Z"
                      fill="#ACACAC"
                    />
                  </svg>
                </span>

                <div className="flex flex-col items-start justify-start w-full">
                  <span className="text-xs text-[#727681]">Telephone</span>
                  <p className="text-black"> {user.msisdn}</p>
                </div>
              </li>
              <li className="flex items-center gap-2">
                <span>
                  <svg
                    width="31"
                    height="32"
                    viewBox="0 0 31 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      y="0.776367"
                      width="30"
                      height="30"
                      rx="3.5"
                      fill="#FBFBFB"
                      stroke="#DEDEDE"
                    />
                    <path
                      d="M8.51925 10.6951C8.36114 10.7851 8.22975 10.9154 8.13852 11.0729C8.0473 11.2303 7.9995 11.4091 8.00001 11.591V21.1204C7.99943 21.2979 8.04487 21.4726 8.13189 21.6274C8.21891 21.7821 8.34455 21.9117 8.49655 22.0034C8.64855 22.0952 8.82173 22.146 8.99921 22.1509C9.17669 22.1558 9.35241 22.1146 9.50924 22.0314C9.52305 22.024 9.53654 22.0163 9.5497 22.0076L12.2516 20.2399C12.2874 20.2165 12.3169 20.1845 12.3373 20.1468C12.3576 20.1091 12.3682 20.0669 12.3681 20.0241V8.54715C12.3683 8.50035 12.3556 8.45441 12.3315 8.41428C12.3075 8.37415 12.2729 8.34136 12.2315 8.31944C12.1902 8.29753 12.1436 8.28733 12.0969 8.28993C12.0502 8.29254 12.0051 8.30787 11.9664 8.33425L8.51925 10.6951ZM13.7916 8.31787C13.7529 8.29269 13.7081 8.27843 13.6619 8.27657C13.6158 8.27472 13.57 8.28535 13.5293 8.30734C13.4887 8.32933 13.4548 8.36187 13.4311 8.40153C13.4074 8.44119 13.3948 8.4865 13.3947 8.5327V20.0145C13.3946 20.0573 13.4052 20.0995 13.4256 20.1372C13.446 20.1749 13.4754 20.2069 13.5113 20.2303L16.594 22.2347C16.6328 22.2599 16.6776 22.2743 16.7239 22.2762C16.7701 22.278 16.816 22.2674 16.8567 22.2454C16.8974 22.2233 16.9313 22.1907 16.955 22.1509C16.9787 22.1112 16.9912 22.0658 16.9912 22.0195V10.5451C16.9913 10.5022 16.9807 10.4599 16.9603 10.4222C16.9399 10.3844 16.9103 10.3524 16.8743 10.329L13.7916 8.31787ZM21.8892 8.54779C21.7377 8.45511 21.5647 8.40373 21.3872 8.39878C21.2097 8.39382 21.034 8.43545 20.8777 8.51953C20.8638 8.52664 20.8504 8.53457 20.8375 8.54329L18.1353 10.3094C18.0995 10.3328 18.07 10.3648 18.0496 10.4025C18.0293 10.4402 18.0187 10.4824 18.0188 10.5252V22.0038C18.0186 22.0506 18.0312 22.0966 18.0553 22.1368C18.0794 22.177 18.114 22.2098 18.1554 22.2317C18.1968 22.2537 18.2435 22.2638 18.2902 22.2612C18.337 22.2585 18.3822 22.2431 18.4208 22.2167L21.859 19.8578C22.019 19.7685 22.1522 19.6381 22.2449 19.48C22.3376 19.3219 22.3862 19.1419 22.3859 18.9586V9.45365C22.3881 9.27268 22.3434 9.09423 22.2564 8.93554C22.1694 8.77685 22.0429 8.6433 21.8892 8.54779Z"
                      fill="#ACACAC"
                    />
                  </svg>
                </span>

                <div className="flex flex-col items-start justify-start w-full">
                  <span className="text-xs text-[#727681]">Address</span>
                  <p className="text-black overflow-hidden overflow-ellipsis whitespace-nowrap md:w-[130px] ">
                    {user?.address}
                  </p>
                </div>
              </li>
              <li className="flex items-center gap-2">
                <span>
                  <svg
                    width="31"
                    height="32"
                    viewBox="0 0 31 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      y="0.776367"
                      width="30"
                      height="30"
                      rx="3.5"
                      fill="#FBFBFB"
                      stroke="#DEDEDE"
                    />
                    <path
                      d="M17.1467 10.0411L16.8 8.27637H9V23.2764H10.7333V17.0999H15.5867L15.9333 18.8646H22V10.0411H17.1467Z"
                      fill="#ACACAC"
                    />
                  </svg>
                </span>

                <div className="flex flex-col items-start justify-start w-full">
                  <span className="text-xs text-[#727681]">Nationality</span>
                  <p className="text-black">
                    {" "}
                    {user?.country && user?.country.citizenship}
                  </p>
                </div>
              </li>
              <li className="flex items-center gap-2">
                <span>
                  <svg
                    width="31"
                    height="32"
                    viewBox="0 0 31 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      y="0.776367"
                      width="30"
                      height="30"
                      rx="3.5"
                      fill="#FBFBFB"
                      stroke="#DEDEDE"
                    />
                    <path
                      d="M21.4737 19.9432H23.1579V20.3599H22.3158V21.1932H23.1579V21.6099H21.4737V22.4432H24V19.1099H21.4737V19.9432ZM22.3158 12.4432H23.1579V9.10986H21.4737V9.9432H22.3158V12.4432ZM21.4737 14.9432H22.9895L21.4737 16.6932V17.4432H24V16.6099H22.4842L24 14.8599V14.1099H21.4737V14.9432ZM8 9.9432H19.7895V11.6099H8V9.9432ZM8 19.9432H19.7895V21.6099H8V19.9432ZM8 14.9432H19.7895V16.6099H8V14.9432Z"
                      fill="#ACACAC"
                    />
                  </svg>
                </span>

                <div className="flex flex-col items-start justify-start w-full">
                  <span className="text-xs text-[#727681]">
                    Commission Number
                  </span>
                  <p className="text-black">0085</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* wallet */}
        <div className="intro-y bg-white px-8 border flex flex-col gap-3 border-theme-31 rounded-md py-7">
          <div className="flex items-center justify-between">
            <span className="tracking-wide font-bold text-lg">Wallets</span>
            <button
              className="btn btn-primary-2 float-right"
              onClick={() => setShowWalletModal(true)}
            >
              Add Wallet
            </button>
          </div>

          <div className="grid grid-cols-4 gap-4">
            {user?.receiver_wallets?.map((wallet, index) => (
              <div key={index} className="">
                <div className="box">
                  <div className="flex flex-col lg:flex-row items-center p-5">
                    <div className="lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0">
                      <div to={`/receiver/${user.id}`} className="font-medium">
                        <span className="font-bold text-md text-gray-500">
                          Institution{" "}
                        </span>
                        {wallet.destination_institution.name}
                      </div>
                      <div className="font-medium">
                        <span className="font-bold text-md text-gray-500">
                          Account Number
                        </span>{" "}
                        {wallet.account_number}
                      </div>
                      <div className="font-medium">
                        <span className="font-bold text-md text-gray-500">
                          Is Validated
                        </span>{" "}
                        {wallet.is_validated ? "True" : "False"}
                      </div>
                      {wallet.is_validated ? (
                        <div className="font-medium">
                          <span className="font-bold text-md text-gray-500">
                            Percentage Name Match
                          </span>{" "}
                          {wallet.percentage_name_match}
                        </div>
                      ) : null}
                      <div className="font-medium">
                        <span className="font-bold text-md text-gray-500">
                          Created On{" "}
                        </span>{" "}
                        {moment(new Date(wallet.created_at)).format(
                          "MMMM DD, YYYY"
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className=" bg-white px-8 border flex flex-col gap-3 border-theme-31 rounded-md py-7">
          <div className="flex items-center justify-between">
            <h2 className="text-base font-medium text-black">Senders</h2>

            <div className="flex items-center gap-4">
              <Search
                placeholder={"Search"}
                onChange={(e) => setSearchQuery(e.target.value)}
              />

              {/* <Link
                to={`/add-identification/2`}
                // to={`/add-identification/${user.id}`}
                className="btn-primary-2  flex items-center gap-2 text-base"
              >
                <span>
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5.98438 1.24805C6.24237 1.24805 6.45151 1.45719 6.45151 1.71519V5.45229H10.1886C10.4466 5.45229 10.6558 5.66144 10.6558 5.91943C10.6558 6.17743 10.4466 6.38657 10.1886 6.38657H6.45151V10.1237C6.45151 10.3817 6.24237 10.5908 5.98438 10.5908C5.72638 10.5908 5.51724 10.3817 5.51724 10.1237V6.38657H1.78013C1.52213 6.38657 1.31299 6.17743 1.31299 5.91943C1.31299 5.66144 1.52213 5.45229 1.78013 5.45229H5.51724V1.71519C5.51724 1.45719 5.72638 1.24805 5.98438 1.24805Z"
                      fill="black"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>

                <span>Add Identification</span>
              </Link> */}
            </div>
          </div>
          <div className="flex w-full flex-col">
            <Table2
              divide="no"
              // headData={head}
              tHead={
                <>
                  <th className="">Name</th>
                  <th className="">Phone Number</th>
                  <th className="">Email</th>
                  <th className="">Country</th>
                  <th className="">Created on</th>
                  {/* <th className="text-center">Action</th> */}
                </>
              }
              // renderHead={(item, index) => renderHeadData(item, index)}
            >
              {/* {user?.identifications?.map((item, index) => ( */}
              {filteredSenders?.map((item, index) => (
                <tr key={index} className="">
                  <td>
                    <div className="flex flex-col">
                      <Link
                        to={`/sender/${item?.id}`}
                        className="text-black font-medium whitespace-nowrap "
                      >
                        {item?.firstname} {item?.lastname}
                      </Link>
                      <div
                        className={
                          item.status === "active"
                            ? "text-green-400 text-xs"
                            : "text-red-400 text-xs"
                        }
                      >
                        {item?.status}
                      </div>
                    </div>
                  </td>
                  <td>
                    <p className=" whitespace-nowrap">{item?.msisdn}</p>
                  </td>
                  <td>
                    <a href={"mailto:" + item?.email}>{item?.email}</a>
                  </td>
                  <td>
                    <p>{item?.country?.name}</p>
                  </td>

                  <td>
                    <p className="font-medium text-black">
                      {moment(new Date(item?.created_at)).format(
                        "MMMM DD, YYYY"
                      )}
                    </p>
                  </td>
                </tr>
              ))}
            </Table2>
          </div>
        </div>
      </div>

      {lightBox.isOpen && (
        <Lightbox
          mainSrc={images[lightBox.photoIndex]}
          nextSrc={images[(lightBox.photoIndex + 1) % images.length]}
          prevSrc={
            images[(lightBox.photoIndex + images.length - 1) % images.length]
          }
          onCloseRequest={() => setLightBox({...lightBox, isOpen: false})}
          onMovePrevRequest={() =>
            setLightBox({
              ...lightBox,
              photoIndex:
                (lightBox.photoIndex + images.length - 1) % images.length,
            })
          }
          onMoveNextRequest={() =>
            setLightBox({
              ...lightBox,
              photoIndex: (lightBox.photoIndex + 1) % images.length,
            })
          }
        />
      )}

      {showWalletModal && (
        <Modal
          onClick={callback}
          modalTitle="Add Wallet"
          buttonTitle="Add Wallet"
          buttonColor={"bg-blue-600"}
          size="small"
          body={
            <AddWallet
              receiver={user}
              initializeCallback={(callbackFunc) =>
                setCallback(() => callbackFunc)
              }
              closeModal={() => {
                setShowWalletModal(false);
                fetchReceiverById(id);
              }}
            />
          }
          onClose={() => {
            setShowWalletModal(false);
          }}
        />
      )}
    </>
  );
};

export default ReceiverProfile;
